<template>
  <div>
    <span>{{ name }}</span>
    <span class="deal-span" @click="dealPreview" v-show="isPreview">预览</span>
    <span class="deal-span" @click="download">下载</span>
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="[url]"
    />
  </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

export default {
  components: { ElImageViewer },
  props: {
    name: {
      type: String,
      default: "",
    },
    url: {
      type: String,
      default: "",
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showViewer: false,
    };
  },
  methods: {
    closeViewer() {
      this.showViewer = false;
    },
    dealPreview() {
      this.showViewer = true;
    },
    download() {
      let a = document.createElement("a"); //创建一个<a></a>标签
      a.href = this.url;
      a.download = this.name;
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a); // 下载完成移除元素
    },
  },
};
</script>

<style lang="scss" scoped>
span {
  margin-right: 10px;
}
.deal-span {
  cursor: pointer;
  color: #3a85ff;
}
</style>
